import React from 'react'
import { sendFirstEnter, sendFirstVisitView,  sendFirstLotView} from '../../store/reducers/role'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { injectIntl, FormattedMessage } from 'react-intl'
import { fetchingState } from '../../helpers/hocs.js'
import Close from "../Icons/Close"
import page from 'page'

//компонент Приветственное уведомление - запускается один раз, когда мы первый раз заходим под ролью персоны
const DynamicBanner = ({user, sendFirstEnter, redirectPage, activeElemRole=null, setActiveRole, onClose, Error=null, text, buttontype, buttonText, id , submit}) => (
    <div className='WelcomePerson'>
      {/* <img className='WelcomePerson-logo' src={"/assets/img/welcomeLogo.png"} /> */}
      <div className='WelcomePerson-inner'>
        <h1 className='WelcomePerson-title'>Здравствуйте!</h1>
        <div className='WelcomePerson-textarea'>
          {
            !text
            ?
            <div>
              <div className='WelcomePerson-text'>
                Мы рады видеть Вас в качестве героя благотворительного аукциона Meet For Charity. 
              </div>
              <div className='WelcomePerson-bottomText'>
                <div className='WelcomePerson-OptionsTitle'>
                  В вашем личном кабинете есть следующие возможности:
                </div>
                <ul className='WelcomePerson-Options'>
                  <li>загрузить фото и биографию</li>
                  <li>согласовать фото и текст для аукциона</li>
                  <li>отслеживать аукцион с вашим участием</li>
                  <li>согласовать дату и время встречи</li>
                </ul>
              </div>
            </div>
            :
            <div className='WelcomePerson-text WelcomePerson-text_message'>
              {text} 
            </div>
          }
        </div>
        <button className='Button Button_black Button_black-white' onClick={buttontype ? submit : sendFirstEnter }>{buttonText ? buttonText : "Понятно"}</button>
      </div>
      <div className='ProfileContainer__modal-close' onClick={onClose}><Close/></div>
    </div>
)

//const mapStateToLogged = state => ({ isLogged: getIsLogged(state) })
const mapStateToProps = ({role}) => ({role})
const mapDispatchToProps = dispatch => bindActionCreators({sendFirstEnter, sendFirstLotView, sendFirstVisitView}, dispatch)

  const mergeProps = (state, dispatch, props) => ({
    ...props,
    ...state,
    sendEnter: (data) => {
      return(props.fetchingWrap(dispatch.sendFirstEnter.bind(this, data), 'send'))
    },
    sendVisitView: (data) => {
      return(props.fetchingWrap(dispatch.sendFirstVisitView.bind(this, data), 'send'))
    },
    sendLotView: (data) => {
      return (props.fetchingWrap(dispatch.sendFirstLotView.bind(this, data), 'send'))
    }
  })

export default injectIntl(compose(
  fetchingState(),
  withState('activeElemRole', 'setActiveElem', null),//хранение выбранной роли по клику
  withState('Error', 'setError', null),//установка ошибки
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withHandlers({
    sendFirstEnter: ({sendEnter, onClose,}) => async (e) => {
      e && e.preventDefault();
      //const data = {init: true};
      const result = await sendEnter();
      if (result === 200) {
        onClose();
      }
    },
    submit: ({buttontype, onClose, sendVisitView, sendLotView, id}) => async (e) => {
      e && e.preventDefault();
      if (buttontype == 'lots'){
        const result = await sendLotView(id)
      }
      else {
        const result = await sendVisitView(id)
      }
      page(`/${buttontype}`);
      onClose();
    },
  }),
)(DynamicBanner))


// WEBPACK FOOTER //
// ./src/components/PersonProfile/DynamicBanner.jsx